export const enum EInviteBuyerType {
    BUYER_INVITATION = "buyer_invitation",
}

export enum EInvitationStatus {
    PENDING = "pending",
    SENT = "sent",
    ACCEPTED = "accepted",
    CANCELED = "canceled",
    EXPIRED = "expired",
    FAILED = "failed",
}

export type TMerchantOrganization = {
    id: string;
    name: string;
    email: string;
    website: string;
    phone: string;
    addresses: TAddress[];
    externalReference: TExternalReference;
    members: TMember[];
    teams: TTeam[];
};

export type TAddress = {
    name: string;
    line1: string;
    line2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
};

export type TExternalReference = {
    system: string;
    id: string;
};

export type TMember = {
    id: string;
    userId: string;
    email: string;
    name: string;
    addedOn: string;
};

export type TTeam = {
    id: string;
    name: string;
    description: string;
    type: string;
    archived: string;
    createdOn: string;
    updatedOn: string;
};
